import React from 'react';
import {obterPublicacao} from '../actions/PublicacaoActions';
import {editarComentario} from '../actions/ComentarioActions';
import {connect} from 'react-redux';
import {FTP_URL} from '../config/urls';

class Publicacao extends React.Component {
  state = {
    paginas: [],
    expandImagem: false,
    backgroundImage: "",
    backgroundPosition: '0% 0%',
    imagemSelecionada: "",
    comentariosImagemSelecionada: ""
  }

  componentWillMount(){
    let id = undefined;
    if(this.props.match === undefined){
      id = this.props.id;
    } else {
      id = this.props.match.params.id;
    }
    this.props.obterPublicacao(id).then(() => {
      let paginas = this.props.publicacao.paginas;
      let tipos = {};
      paginas.forEach(pagina => {
        if(!tipos[pagina.tipo]){
          tipos[pagina.tipo] = [];
        }
        tipos[pagina.tipo].push(pagina);
      });
      let paginasOrdenadas = [];
      Object.values(tipos).forEach(paginasArray => {
        paginasArray.sort((a, b) => a.numero - b.numero);
        paginasOrdenadas = paginasOrdenadas.concat(paginasArray);
      });
      this.setState({paginas: paginasOrdenadas});
    });
  }

  componentDidUpdate(){
    this.state.paginas.forEach(pagina => {
      pagina.comentarios.forEach((comentario, i) => {
        let imagem = document.querySelector(`#pagina${pagina.id}`);
        let wrapper = document.createElement('div');
        wrapper.style.position = "absolute";
        wrapper.style.left = `calc(${comentario.posX} - 15px)`;
        wrapper.style.top = `calc(${comentario.posY} - 45px)`;
        wrapper.style.fontFamily = "Arial, Helvetica, sans-serif";
        wrapper.innerHTML = `<p style="color: #bbb; background-color: rgba(0,0,0,1); padding: 2px 8px; border-radius: 25px; position: absolute">${i+1}</p>`;
        let alfinete = document.createElement('img');
        alfinete.src = "/images/pin-icon.png";
        alfinete.style.width = "50px";
        wrapper.classList.add("alfinete");
        wrapper.appendChild(alfinete);
        imagem.appendChild(wrapper);
      });
    });
  }

  handleMouseMove = e => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = (e.pageX - left) / width * 100;
    const y = (e.pageY - top) / height * 100;
    this.setState({ backgroundPosition: `${x}% ${y}%` });
  }

  removerBackgroundImg () {
    document.querySelector("#figura-expandImg").style.backgroundImage = "";
  }

  adicionarBackgroundImg () {
    document.querySelector("#figura-expandImg").style.backgroundImage = this.state.imagemSelecionada;
  }


  render(){
    return(
      <div className="box">
        <div className="box-body">
          {
            this.state.paginas.sort((a,b)=>{return a.numero - b.numero}).map((pagina) => (
              <div key={pagina.id}style={{marginBottom: 30, display: "flex", flexDirection: "column"}}>
                <span style={{fontWeight: "bold"}}><i className="fa fa-search-plus hidden-xs hidden-sm" data-target="#expandImg" data-toggle="modal" onClick={() => {this.setState({imagemSelecionada: `url(${FTP_URL}${pagina.publicacao}/${pagina.nome})`, comentariosImagemSelecionada: pagina.comentarios})}} style={{fontSize: 18, cursor: "pointer"}}></i> | {pagina.tipo.toUpperCase() + " " + pagina.numero}</span>
                <div style={{display: "flex", flexDirection: "row"}}>
                  <div>
                  <div id={`pagina${pagina.id}`} style={{position: "relative"}}>
                    <img id={`pagina-${pagina.id}`} style={{maxHeight: 250}} onClick={() => {
                      let foto = document.querySelector(`#pagina-${pagina.id}`);
                      let tamanho = "250px";
                      if (foto.style.maxHeight === "250px") {
                        tamanho = "500px";
                      } else if (foto.style.maxHeight === "500px") {
                        tamanho = "900px";
                      } else if (foto.style.maxHeight === "900px") {
                        tamanho = "250px";
                      }
                      foto.style.maxHeight = tamanho;
                    }} src={`${FTP_URL}${this.props.publicacao.id}/${pagina.nome}`} />
                  </div>
                  </div>
                  <div style={{display: "flex", overflowX: "auto"}}>
                    { 
                      pagina.aprovada === false ? 
                        pagina.comentarios.length > 0 ?  
                          pagina.comentarios.map((comentario, i) => (
                            <div key={comentario.id} className="box box-danger" style={{marginLeft: 20, maxWidth: 300, minWidth: 300}}>
                              <div className="box-header with-border">
                                <h3 className="box-title" style={{color: 'black'}}>Correção {i+1} - {new Date(comentario.data).toLocaleDateString('pt-BR', {timeZone: 'UTC'})}</h3>
                                <div className="pull-right box-tools">
                                <input type="checkbox" checked={comentario.corrigido ? true : false} onChange={event => {
                                    let paginas = this.state.paginas;
                                    for(let j=0;j<paginas.length;j++){
                                      if(paginas[j].id===pagina.id){
                                        for(let k=0;k<paginas[j].comentarios.length;k++){
                                          if(paginas[j].comentarios[k].id===comentario.id){
                                            comentario.corrigido = !comentario.corrigido;
                                            this.props.editarComentario(comentario, comentario.id);
                                            paginas[j].comentarios[k] = comentario;
                                            this.setState({paginas});
                                            break;
                                          }
                                        }
                                      }
                                    }
                                  }} />
                                </div>
                              </div>
                              <div className="box-body">
                                <textarea rows="3" style={{minWidth: "100%"}} readOnly defaultValue={comentario.texto}></textarea>
                              </div>
                            </div>
                          )) 
                        : null
                      : <div key={pagina.numero} className="box box-success" style={{marginLeft: 20, maxWidth: 300, minWidth: 300}}> 
                          Página aprovada em {new Date(pagina.dataAprovacao).toLocaleDateString('pt-BR', {timeZone: 'UTC'})} 
                        </div>
                    }
                  </div>
                </div>
                <div className="modal fade in" id="expandImg" style={{padding: 0}}>
                  <div className="modal-dialog modal-lg" style={{width:"100vw", height: "100vh", display: "flex", flexDirection: "column", padding: "30px", margin: 0}}>
                    <div style={{display: "flex", justifyContent: "space-between", marginBottom: 30}}>
                      <h3 style={{color: "#fff", fontWeight: 600}}>{`${pagina.tipo} - Página ${pagina.numero}`}</h3>
                      <button type="button" className="close" data-dismiss="modal" aria-label="close" style={{color: "#fff", opacity: 1}}><i className="fa fa-times"></i></button>
                    </div>
                    <h5 style={{textAlign: "center", color: "#fff"}}>Passe o mouse pela imagem</h5>
                    <figure id="figura-expandImg" onMouseEnter={this.adicionarBackgroundImg.bind(this)} onMouseLeave={this.removerBackgroundImg.bind(this)} onMouseMove={this.handleMouseMove.bind(this)} style={{backgroundImage: this.state.backgroundImage, backgroundPosition: this.state.backgroundPosition}}>
                      <img src={`${FTP_URL}${pagina.publicacao}/${pagina.nome}`}/>
                    </figure>
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    publicacao: state.publicacao.especifica
  }
}

export default connect(mapStateToProps, {obterPublicacao, editarComentario})(Publicacao);



// WEBPACK FOOTER //
// ./src/views/Publicacao.js